import { useBunja } from 'bunja/react';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import LockClosedIcon from '@flipster/react/icon/generated/LockClosedIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { ProfileEvent } from '@flipster/utils/segment/events/profile';

import { editProfileActionBunja } from '../../../bunja';

export const ShowBothToPublic = () => {
  const t = useTranslations();
  const { changeBothVisibilityToPublic } = useBunja(editProfileActionBunja);
  return (
    <div className={hstack({ gap: 12 })}>
      <div>
        <LockClosedIcon size={20} color={token('colors.content.default.level-5')} />
      </div>
      <div className={stack({ gap: 4 })}>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Set_both_Performance_and_Trading_activity_to_public_to_display_your_social_links' />
        </p>
        <div>
          <TextButton
            label={t('Autogen_common.r251126.s_Set_both_to_public')}
            onClick={() => {
              segment.track(ProfileEvent.SwitchToPublicLinkClick);
              changeBothVisibilityToPublic();
            }}
          />
        </div>
      </div>
    </div>
  );
};
